import {MuUi, MuWidget} from "mu-widget/lib/MuWidget";
import {emptyToNull, flashError, flashInfo, formatDate, getSelectedValue, Objects, setSelectedValue} from "../Utils";
import {CalCL} from "../generated/CalCL";
import {ErrorMarkerError, ErrorMarkerErrors} from "../ErrorMarker";
import {CalItemRepeating} from "../CommonTypes";

export class DateRepeating extends MuWidget {
	cl = new CalCL();
	beforeIndex() {
		this.muRegisterEvent('changeType');
		this.muAppendContent(`
			<div class="row form-group">
				<label class="col-sm-3 control-label" mu-for="type">Opakování</label>
				<div class="display-flex col-9">
					<div class="radiolist-horizontal flex-grow-1">
						<label mu="lNone"><input type="radio" mu-change="type_change" mu-name="type" value="none">Jednorázově</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="week" mu="type_week">Týdně</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="month">Měsíčně</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="month3">Čtvrtletně</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="month6">Půlročně</label>
						<label><input type="radio" mu-change="type_change" mu-name="type" value="year">Ročně</label>
					</div>
					<span class="btn btn-default" mu="bTest">Ukaž data</span>
				</div>
				<input type="hidden" mu-bind="type" />
				<div class="col-3"></div><div class="col-md-9" mu-for="error:type"></div>
			</div>
			<div mu="pDayOfWeek" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="dayOfWeek">Den v týdnu</label>
				<div class="col-sm-9">
					<select mu="dayOfWeek#dayOfWeek;dayList:@options" class="form-control"></select>
				</div>
			</div>	
			<div mu="pDayOfMonth" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="dayOfMonth">Den v měsíci</label>
				<div class="col-sm-9">
					<div class="display-flex">
						<input type="number" mu="dayOfMonth#dayOfMonth" class="form-control flex-grow-1" min="-29" max="31" />
						<span class="">
							<span class="icon-help" title="Zadejte číslo dne v měsící nebo 0 pro poslední den v měsící, nebo záporné číslo den v měsíci od konce"></span>
						</span>
					</div>
					<div mu-for="error:dayOfMonth"></div>
				</div>
			</div>
			<div mu="pMonthMod" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="monthMod">Měsíc</label>
				<div class="col-sm-9">
					<select type="number" mu="monthMod#monthMod;monthList:@options" class="form-control"></select>
				</div>
			</div>	
			<div mu="pFromTo" class="row form-group">
				<label class="col-sm-3 control-label" mu-for="dtFrom">Platnost od</label>
				<div class="col-sm-3">
					<input type="date" mu="dtFrom#dtFrom|dateToInputD" class="form-control">
				</div>
				<label class="col-sm-3 control-label text-center" mu-for="dtTo">do</label>
				<div class="col-sm-3">
					<input type="date" mu="dtTo#dtTo|dateToInputD" class="form-control">
				</div>
			</div>
		`)
	}

	// @ts-ignore
	ui: MuUi<{
		dayOfWeek: HTMLSelectElement,
		dayOfMonth: HTMLInputElement,
		monthMod: HTMLSelectElement,
		dtFrom: HTMLInputElement,
		dtTo: HTMLInputElement,
	}>

	afterIndex() {
		let n = 0;
		this.muBindData({ dayList: [
			{ text: "Vyberte den", value: ""},
			...DateRepeating.dayNames.map(name => ({ text: name, value: n++}))
		]});
		this.update();
	}

	static dayNames = [
		'Pondělí',
		'Úterý',
		'Středa',
		'Čtvrtek',
		'Pátek',
		'Sobota',
		'Neděla',
	];

	static monthNames = [
		'Leden',  // '1 - Leden',
		'Únor',  // '2 - Únor',
		'Březen',  // '3 - Březen',
		'Duben',  // '4 - Duben',
		'Květen',  // '5 - Květen',
		'Červen',  // '6 - Červen',
		'Červenec',  // '7 - Červenec',
		'Srpen',  // '8 - Srpen',
		'Září',  // '9 - Září',
		'Říjen',  // '10 - Říjen',
		'Listopad',  // '11 - Listopad',
		'Prosinec',  // '12 - Prosinec',
	];

	type_change() {
		this.update();
		this.muDispatchEvent("changeType", this.type);
	}

	get type(): DateRepeatingType|null  {
		// @ts-ignore
		return getSelectedValue(this.ui.type_week);
	}

	set type(value: DateRepeatingType|null) {
		// @ts-ignore
		setSelectedValue(this.ui.type_week, value);
	}

	set hideNone(hidden: boolean) {
		this.muVisible(!hidden, 'lNone');
	}

	typePeriod = {
		month: 1,
		month3: 3,
		month6: 6,
		year: 12,
	}

	public update() {
		this.muVisible(this.type === "week", "pDayOfWeek");
		this.muVisible(![null, "none", "week"].includes(this.type!), "pDayOfMonth");
		this.muVisible(![null, "none", "week", "month"].includes(this.type!), "pMonthMod");
		this.muVisible((this.type !== null) && (this.type !== "none"), 'pFromTo');

		// @ts-ignore
		const period: number|undefined = this.typePeriod[this.type];

		if (period) {
			const opts: Record<number, string> = {};
			for(let mm = 0; mm < period; mm++) {
				const months = DateRepeating.getMonthsByPeriod(period, mm);
				opts[mm] = months;
			}

			this.muBindData({ monthList: opts });
		}

		this.muVisible(![null, "none"].includes(this.type), "bTest");
	}

	public static getMonthsByPeriod(period: number, mm: number): string {
		const months = [];
		for(let mi = mm; mi < 12; mi += period) {
			months.push(DateRepeating.monthNames[mi]);
		}

		return months.join(', ');
	}

	muFetchData(): DateRepeatingData|null {
		const res: DateRepeatingData = {
			dayOfMonth: null,
			dayOfWeek: null,
			monthMod: null,
			monthPeriod: null,
			dtFrom: emptyToNull(this.ui.dtFrom.value),
			dtTo: emptyToNull(this.ui.dtTo.value),
		}

		switch (this.type) {
			case "month3":
			case "month6":
			case "year":
			case "month":
				res.monthPeriod = this.typePeriod[this.type];
				res.monthMod = parseInt(this.ui.monthMod.value);
				res.dayOfMonth = this.ui.dayOfMonth.valueAsNumber;
				break;
			case "week":
				res.dayOfWeek = parseInt(this.ui.dayOfWeek.value);
				break;
			default:
				return null;
		}

		return res;
	}

	muBindData(srcData: DateRepeatingData) {
		super.muBindData(srcData);
		if (srcData.dayOfWeek) {
			this.type = "week";
			this.update();
		} else if (srcData.monthPeriod) {
			this.type = Objects.swapKeysValues(this.typePeriod)[srcData.monthPeriod!];
			this.update();
		}
	}

	async bTest_click() {
		const errs = this.checkForm();
		if (errs) {
			flashError("Nejprve opravte: " + errs.map(e => e.message).join(", "));
		} else {
			flashInfo("Tato položka se bude opakovat: \n"
				+ (await this.cl.getPlannedDates(this.muFetchData(), 20, this.ui.dtFrom.value))
					.map((d: Date) => formatDate("d.m.Y", d))
					.join('\n')
				+ '\n...'
			);
		}
	}

	public checkForm(): ErrorMarkerErrors|null {
		const errors = new ErrorMarkerErrors();
		switch (this.type) {
			case "month3":
			case "month6":
			case "year":
			case "month":
				if (isNaN(this.ui.dayOfMonth.valueAsNumber)) errors.add("dayOfMonth", "Vyberte v měsíci");
				if (!this.ui.monthMod.value) errors.add("monthMod", "Vyberte měsíc");
				break;
			case "week":
				if (!this.ui.dayOfWeek.value) errors.add("dayOfWeek", "Vyberte den v týdnu");
				break;
			case "none":
				break;
			default:
				errors.add("type", "Vyberte opakování");
				break;
		}

		return errors.length ? errors : null;
	}

	public static getTextInfo(data: DateRepeatingData|CalItemRepeating) {
		if (typeof data.dayOfWeek === "number") {
			return "Každý týden v " + DateRepeating.dayNames[data.dayOfWeek];
		}
		let text = "";
		switch (data.monthPeriod) {
			case 1:
				text += "Každý měsíc";
				break;
			case 3:
				text += "Čtvrtletně";
				break;
			case 6:
				text += "Pololetně";
				break;
			case 12:
				text += "Ročně";
				break;
		}
		text += " ";
		if (data.dayOfMonth === 0) text += "poslední den v měsící";
		else if (data.dayOfMonth! > 28) text += data.dayOfMonth + ". nebo poslední den v měsíci";
		else if (data.dayOfMonth! > 1) text += data.dayOfMonth + ". den v měsíci";
		else text += data.dayOfMonth + ". den před koncem měsíce";
		if (data.monthPeriod! > 1) text += " " + DateRepeating.getMonthsByPeriod(data.monthPeriod!, data.monthMod!);

		return text;
	}
}

export type DateRepeatingType = "none"|"week"|"month"|"month3"|"month6"|"year";

export type DateRepeatingData = {
	dtFrom: string|null,
	dtTo: string|null,
	dayOfWeek: number|null,
	dayOfMonth: number|null,
	monthPeriod: number|null,
	monthMod: number|null,
};